import { palette2, RcClasses, } from '../../../../foundation';
export var RcButtonClasses = RcClasses(['disabled', 'contained', 'text', 'outlined', 'endIcon', 'startIcon'], 'RcButton');
export var RcButtonColors = {
    primary: palette2('interactive', 'b02'),
    secondary: palette2('highlight', 'b03'),
    negative: palette2('danger', 'b04'),
    positive: palette2('success', 'b04'),
    action: palette2('neutral', 'elevation'),
    neutral: palette2('neutral', 'b04'),
};
export var RcButtonTextColors = {
    primary: palette2('interactive', 'f01'),
    secondary: palette2('highlight', 'f02'),
    negative: palette2('danger', 'f02'),
    positive: palette2('success', 'f02'),
    action: palette2('neutral', 'f01'),
    neutral: palette2('neutral', 'f04'),
};
export var RcButtonTypographies = {
    xsmall: 'caption1',
    small: 'caption2',
    medium: 'body2',
    large: 'body2',
    xlarge: 'subheading2',
};
export var RcButtonHeights = {
    xsmall: 24,
    small: 28,
    medium: 32,
    large: 36,
    xlarge: 48,
};
export var RcButtonMinWidths = {
    xsmall: 0,
    small: 0,
    medium: 88,
    large: 96,
    xlarge: 140,
};
export var RcButtonPadding = {
    xsmall: 2,
    small: 4,
    medium: 3,
    large: 4,
    xlarge: 5,
};
export var RcButtonIconSpace = {
    xsmall: 1,
    small: 1.5,
    medium: 2,
    large: 2,
    xlarge: 3,
};
